import React, { useRef } from "react";
import { Link } from "react-router-dom";
import {
    LayoutDashboard,
    BarChart2,
    Cpu,
    Settings,
    Bell,
    LogOut,
    TestTube2,
    Menu,
    Map,
    Users,
    MessageSquare,
    CalendarDays,
} from "lucide-react";
import "../style/Sidebar.css";

const Sidebar = ({ isOpen, setIsOpen }) => {
    const sidebarRef = useRef(null);

    const user = JSON.parse(localStorage.getItem("user"));
    const userName = user ? user.nombre : "Usuario";

    const handleOverlayClick = (e) => {
        if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };

    return (
        <>
            {isOpen && <div className="menu-overlay" onClick={handleOverlayClick}></div>}
            <aside
                ref={sidebarRef}
                className={`vertical-menu${isOpen ? " expanded" : " collapsed"}`}
                onClick={() => !isOpen && setIsOpen(true)}
            >
                {!isOpen && (
                    <button className="menu-btn" onClick={() => setIsOpen(true)}>
                        <Menu className="icon" />
                    </button>
                )}

                <div className="menu-profile">
                    <div className="profile-pic" />
                    {isOpen && <div className="font-bold">{userName}</div>}
                </div>


                <div className="menu-section">
                    <ul>
                        <li>
                            <LayoutDashboard className="icon" />
                            {isOpen && <Link to="/dashboard">Dashboard</Link>}
                        </li>
                        <li>
                            <Cpu className="icon" />
                            {isOpen && <Link to="/devices">Dispositivos</Link>}
                        </li>

                        <li>
                            <Map className="icon" />
                            {isOpen && <Link to="/terrenos">Terrenos</Link>}
                        </li>
                        <li>
                            <Users className="icon" />
                            {isOpen && <Link to="/weather">Clima</Link>}
                        </li>
                        <li>
                            <MessageSquare className="icon" />
                            {isOpen && <Link to="/chats">Chats</Link>}
                        </li>

                        <li>
                            <BarChart2 className="icon" />
                            {isOpen && <Link to="/analicis">Analytics</Link>}
                        </li>

                        <li>
                            <CalendarDays className="icon" />
                            {isOpen && <Link to="/calendario">Calendario</Link>}
                        </li>


                        <li>
                            <Bell className="icon" />
                            {isOpen && <Link to="/alertas">Alertas</Link>}
                        </li>



                        <li>
                            <TestTube2 className="icon" style={{ color: "#a855f7" }} />
                            {isOpen && <Link to="/beta">Funciones Beta</Link>}
                        </li>
                    </ul>
                </div>

                <div className="menu-divider" />


                <div className="menu-settings">
                    {isOpen && (
                        <button
                            className="logout"
                            onClick={() => {
                                localStorage.removeItem("token");
                                localStorage.removeItem("user");
                                window.location.href = "/login";
                            }}
                        >
                            <LogOut className="icon" /> Cerrar sesión
                        </button>
                    )}
                </div>
            </aside>
        </>
    );
};

export default Sidebar;
